import React from 'react';
import { createRoot } from 'react-dom/client';
import { StyleSheetManager } from 'styled-components';

import PreviewToolbarWidget from './PreviewToolbarWidget';
import { isLiveSite } from './utils/isLiveSite';

const renderToolbar = () => {
  // Check if it's a live site; if true, do not render the toolbar
  if (isLiveSite()) return;

  document.addEventListener('DOMContentLoaded', () => {
    // Create the shadow host
    const rootEl = document.createElement('div');
    rootEl.id = 'contensis-blocks-preview-toolbar';
    document?.body?.appendChild(rootEl);

    // Get the shadow host
    const host = document.querySelector('#contensis-blocks-preview-toolbar');

    // Create a shadow root inside the host
    const shadow = host?.attachShadow({ mode: 'open' });

    // Create a slot to attach the StyleSheetManager
    const slot = document.createElement('section');

    // Append the slot inside the shadow root
    shadow?.appendChild(slot);

    // Create the element for rendering the app
    const container = document.createElement('div');
    container.id = 'contensis-blocks-preview-toolbar-widget';

    // Append the rendering element inside the slot
    slot.appendChild(container);

    const root = createRoot(container);
    // Render the app using StyleSheetManager
    root.render(
      <StyleSheetManager target={slot}>
        <PreviewToolbarWidget />
      </StyleSheetManager>
    );
  });
};

renderToolbar();
